import { Navigate, useLocation } from "react-router-dom";

const RequireAuth = ({ children }) => {
    const user = localStorage.getItem("auth");
    let location = useLocation();
    if (!user) {
        return <Navigate to="/" state={{ from: location }} replace />;
    } else {
        return children;
    }
};

export default RequireAuth;
